// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__dialog___3Sxrh {\n  max-height: 90%;\n  display: flex;\n  width: 1100px !important\n}\n\n.css__dialog___3Sxrh > div:first-of-type {\n    //padding: 0px 0px 10px 0px !important;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    color: var(--color-text);\n  }\n\n.css__itemGrid___1ClsR {\n  margin-top: 16px;\n  margin-left: -12px;\n  min-height: 225px;\n  overflow-y: auto;\n}\n\n.css__actionContainer___UnTWg {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.css__messageList___375l8 {\n  margin-bottom: 16px;\n  margin-right: -12px;\n}\n\n.css__titleContainer___3km0O {\n  display: flex;\n}\n\n.css__loading___1wOJ1 {\n  margin-top: 6px;\n}", ""]);
// Exports
exports.locals = {
	"dialog": "css__dialog___3Sxrh",
	"itemGrid": "css__itemGrid___1ClsR",
	"actionContainer": "css__actionContainer___UnTWg",
	"messageList": "css__messageList___375l8",
	"titleContainer": "css__titleContainer___3km0O",
	"loading": "css__loading___1wOJ1"
};
module.exports = exports;
